if (!customElements.get('extended-filters')) {

    class AdditionalFacetFilters extends SideDrawer {

        /**
         * Initialize the component
         */
        connectedCallback() {
            this.productCollection = {};
            this.responseProductCollection = {};

            // Metafield ID for the product_spec_table
            this.productSpecTableMetafildId = 'product_spec_table';

            // Metafield ID for the product_details
            this.productDetailsMetafildId = 'product_details';

            // Metafield ID for product's free shipping attribute
            this.productFreeShippingMetafieldId = 'free_shipping';

            // Metafield ID for the rep_model
            this.productReplacementModelMetafildId = 'rep_model';

            // Metafield ID for the rs_qs_inventory
            this.productRsQsInventorylMetafildId = 'rs_qs_inventory';

            // Metafield ID for the quick_ship
            this.productQuickShipMetafildId = 'quick_ship';

            // Metafield ID for the bestselle product_ranking
            this.productBestsellerProductRankingMetafildId = 'product_ranking';

            // Status object
            this.netsuiteItemStatusObject = {
                available: 'Available',
                discontinued: 'Discontinued',
                specialQuote: 'Special Quote Item',
                outOfStock: 'Out of Stock',
                null: null
            }

            // Skip the following facet items
            this.skipFacetItems = [
                'manufacturer',
                'model_number',
                'manufacturer_part',
                'upc',
                'product_category'
            ];

            //Boosting Logic
            this.netsuiteItemStatusSpecialQuoteItem = 'Special Quote Item';
            this.netsuiteItemStatusDiscontinued = 'Discontinued';
            this.netsuiteItemStatusOutOfStock = 'Out of Stock';

            this.boostVendors = [
                'Chef Approved',
                'Empura Equipment',
                'Empura Refrigeration',
                'Empura Stainless'
            ];

            this.boostAllPointsVendors = [
                'AllPoints',
                'Allpoints',
                'AllPoints Foodservice Parts & Supplies'
            ];

            this.richpanel_link = theme.settings.requestAQuoteLink;

            // Enable debug mode
            this.enabledDebug = false;

            // Initialize the component
            this.init();
        }

        /**
         * Initialize the component
         */
        init() {
            this.currentPage = 1;
            this.activeFilters = {};
            this.paginationContainer = '';
            this.perPage = this.dataset.products_per_page;
            this.showMaxFilterOptions = this.dataset.max_filter_options;
            this.addToCartText = this.dataset.add_to_cart_text;
            this.requestAQuoteText = this.dataset.request_a_quote_text;
            this.viewReplacementItemText = this.dataset.view_replacement_item_text;
            this.filteringEnabled = this.dataset.filtering === 'true';
            this.results = document.getElementById('filter-results');
            this.preloader = document.querySelector('.extended-facets__filters');
            this.additionalFacetsBlock = this.querySelector('.extended-facets__filters');
            this.productThumbnailPlaceholder = this.querySelector('.product-thumbnail-placeholder');
            this.productQuickshipBadge = document.querySelector('.product-quickship-badge');
            this.productBestsellerProductRankingBadge = document.querySelector('.product-bestseller-badge');
            this.activeFiltersSection = document.querySelector('.disclosure__content .active-filters');
            this.productItemAddToCartBtnClass = theme.website === 'restaurantsupply' ? 'btn--secondary' : 'btn--primary';

            this.getProductCollection().then(r => {
                this.extendProductCollectionData(this.productCollection, 'value', 'asc');
                this.initEventListeners();
            });
        }

        /**
         * Initialize event listeners
         */
        initEventListeners() {
            if (this.filteringEnabled) {
                this.filters = this.additionalFacetsBlock;
                this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
                this.activeFiltersSection.addEventListener('click', this.handleActiveFacetsClick.bind(this));
            }
        }

        /**
         * Fetch product collection
         * @returns {Promise<void>}
         */
        async getProductCollection() {
            this.productCollection = this.responseProductCollection = await this.getProductCollectionEvent();
        }

        /**
         * Fetch product collection event listener
         * @returns {Promise<unknown>}
         */
        getProductCollectionEvent() {
            return new Promise((resolve) => {
                let isResolved = false;
                const eventHandler = (event) => {
                    if (isResolved) return;

                    if (event.detail.productCollection) {
                        this.productCollection = event.detail.productCollection;

                        if (event.detail.message === 'fetched_all_products') {
                            // Sync the full product collection
                            this.syncFullProductCollectionEvent(this.productCollection);
                            isResolved = true;
                            resolve(this.productCollection);
                        } else {
                            resolve(this.productCollection);
                        }
                    } else {
                        isResolved = true;
                        resolve({});
                    }
                };

                window.addEventListener('productCollectionFetched', eventHandler);
            });
        }

        /**
         * Sync full product collection event - used for the initial load
         * @param productCollection
         */
        syncFullProductCollectionEvent(productCollection) {
            this.extendProductCollectionData(productCollection, 'value', 'asc');
            this.productCollection = this.responseProductCollection = productCollection;
        }

        /**
         * Extend product collection data
         * @param collection
         * @param sortBy
         * @param order
         */
        extendProductCollectionData(collection, sortBy = 'count', order = 'desc') {
            let facetItems = {};
            let totalProductCount = 0;

            // Exclude products based on the conditions - discontinued or price of 0
            this.excludeProductItems(collection);

            if (!collection.products || collection.products.length === 0) {
                return;
            }

            collection.products.forEach(product => {
                let extendProductItemFilters = [];

                if (product.node.metafields && product.node.metafields.length > 0) {
                    product.node.metafields.forEach(metafield => {

                        //Getting product_details Json Data
                        if (metafield && metafield.key === this.productDetailsMetafildId) {
                            let productDetailsAttributes = JSON.parse(metafield.value);

                            productDetailsAttributes.forEach(attr => {
                                if (attr.key === "netsuite_item_status") {
                                    attr.value !== "" ? product.node[attr.key] = attr.value : product.node[attr.key] = null;
                                }
                            });
                        }

                        //Getting rep_model reference link
                        if (metafield && metafield.key === this.productReplacementModelMetafildId) {
                            product.node.replacement_item_handle = metafield.reference.handle;
                        }

                        // Getting Bestseller product_ranking JSON Data
                        product.node.bestseller_product_ranking = false;
                        if (metafield && metafield.key === this.productBestsellerProductRankingMetafildId) {
                            let productBestsellerRankingAttributes = JSON.parse(metafield.value);
                            if (Array.isArray(productBestsellerRankingAttributes) && productBestsellerRankingAttributes.length > 0) {
                                product.node.bestseller_product_ranking = true;
                            }
                        }

                        //Getting rs_qs_inventory value
                        if (metafield && metafield.key === this.productRsQsInventorylMetafildId) {
                            product.node.rs_qs_inventory = metafield.value === "true" ? true : false;
                        }

                        //Getting product_spec_table Json Data
                        if (metafield && metafield.key === this.productSpecTableMetafildId) {
                            let attributes = JSON.parse(metafield.value);

                            attributes.forEach(attribute => {
                                let key = attribute.key;
                                let value = attribute.value;
                                let show_value = attribute.value;
                                let name = attribute.name;

                                // Skip if the key is in the skipFilters array
                                if (this.skipFacetItems.includes(key)) {
                                    return;
                                }

                                // Convert the value to remove unwanted characters and spaces
                                value = value.toString().replace(/[^\w.-]/g, '').trim();

                                // Add the attribute to the product node
                                product.node[key] = value;

                                // Push the filter for this specific product
                                const isKeyPresent = extendProductItemFilters.some(item => item.hasOwnProperty(key));

                                // If the key is not found, push the new key-value pair
                                // Fix DUPLICATION of the filters - used first value as a key
                                if (!isKeyPresent) {
                                    extendProductItemFilters.push({ [key]: value });

                                    if (!facetItems[key]) {
                                        facetItems[key] = {};
                                    }

                                    if (!facetItems[key][value]) {
                                        facetItems[key][value] = {
                                            key: key,
                                            value: value,
                                            show_value: show_value,
                                            name: name,
                                            count_product: 0
                                        };
                                    }

                                    facetItems[key][value].count_product++;
                                }
                            });
                        }
                    });
                }

                //Preparing product variants for free_shipping and quick_ship values
                if (product.node.variants.edges && product.node.variants.edges.length > 0) {
                    if (product.node.variants.edges[0].node.metafields && product.node.variants.edges[0].node.metafields.length > 0) {
                        product.node.variants.edges[0].node.metafields.forEach(metafield => {

                            //Getting variant product_free_shipping value
                            if (metafield && metafield.key === this.productFreeShippingMetafieldId) {
                                product.node.free_shipping = metafield.value === "true" ? true : false;
                            }

                            //Getting variant quick_ship value
                            if (metafield && metafield.key === this.productQuickShipMetafildId) {
                                product.node.quick_ship = metafield.value === "true" ? true : false;
                            }
                        });
                    }
                }

                product.node.extendProductItemFilters = extendProductItemFilters;
            });

            // Sort facetItems based on the sortBy and order parameters
            for (let key in facetItems) {
                facetItems[key] = this.sortFiltersValues(facetItems[key], sortBy, order);
            }

            // Initialize productCollection
            this.productCollection = collection;
            this.facetItems = facetItems;

            if (collection.products && collection.products.length > 0) {
                totalProductCount = collection.products.length;
            }

            // Render facets/filters on the DOM
            this.renderFiltersBlock(facetItems, totalProductCount);
        }

        /** Sorting function for facet values */
        /*** Alphabetical Sorting: 'name', 'value' -> Sort by name A-Z */
        /*** Numerical Sorting by Value: 'value', 'asc' -> Sort by value (numbers or text) */
        /*** Sorting by Product Count: 'count', 'desc' -> Sort by product count, descending */
        sortFiltersValues(facets, sortBy, order) {
            let sortedFacets = Object.values(facets).sort((a, b) => {
                if (sortBy === 'name') {
                    // Alphabetical sort by name
                    return a.name.localeCompare(b.name);
                } else if (sortBy === 'value') {
                    // Numerical or alphabetical sort by value
                    const numA = parseFloat(a.value);
                    const numB = parseFloat(b.value);
                    if (!isNaN(numA) && !isNaN(numB)) {
                        return numA - numB;
                    } else {
                        return a.value.localeCompare(b.value);
                    }
                } else {
                    // Default sort by count_product
                    return a.count_product - b.count_product;
                }
            });

            // Reverse for descending order
            if (order === 'desc') {
                sortedFacets.reverse();
            }

            return sortedFacets;
        }

        /**
         * Exclude products based on the conditions
         * @param collection
         * @returns {{products}|*}
         */
        excludeProductItems(collection) {
            if (!collection.products || collection.products.length === 0) {
                return collection;
            }

            collection.products = collection.products.filter(product => {
                let netsuiteItemStatus = null;
                let price = parseFloat(product.node.variants.edges[0].node.price.amount) || 0; // Ensure valid number

                if (product.node.metafields && product.node.metafields.length > 0) {
                    product.node.metafields.forEach(metafield => {
                        if (metafield && metafield.key === this.productDetailsMetafildId) {
                            let productDetailsAttributes = JSON.parse(metafield.value);
                            productDetailsAttributes.forEach(attr => {
                                if (attr.key === "netsuite_item_status") {
                                    netsuiteItemStatus = attr.value || null;
                                }
                            });
                        }
                    });
                }

                // Exclude products that are discontinued or have a price of 0
                if (netsuiteItemStatus === this.netsuiteItemStatusObject.discontinued || price === 0) {
                    return false;
                }

                return true;
            });

            return collection;
        }

        /**
         * Add filters dynamically to the DOM
         * @param facetItems
         * @param totalProductCount
         */
        renderFiltersBlock(facetItems, totalProductCount) {
            const container = this.additionalFacetsBlock;
            if (!container) return;
            container.innerHTML = '';

            const sortedFacetGroups = Object.keys(facetItems).sort().map(key => ({ key, items: facetItems[key] }));
            sortedFacetGroups.forEach(group => {
                const key = group.key;
                const items = group.items;

                let detailsElement = document.createElement('details');
                detailsElement.classList.add('filter', 'disclosure');

                const allItemsHidden = items.every(facet => facet.count_product === totalProductCount);
                if (this.activeFilters[key] && this.activeFilters[key] || allItemsHidden) {
                    detailsElement.classList.add('hidden'); // Hide the facet if it has active filters
                }

                detailsElement.id = `filter-${key}`;
                detailsElement.dataset.type = 'list';

                // Assign a unique ID for each facet's list
                const listId = `facet-list-${key}`;

                detailsElement.innerHTML = `
                    <summary class="filter__toggle">
                        <div class="flex justify-between items-center">
                            <span class="flex-auto font-bold">${items[0].name}</span>
                            <span class="disclosure__toggle"></span>
                        </div>
                    </summary>
                    <div class="disclosure__panel has-motion">
                        <div class="disclosure__content">
                            <fieldset class="filter__content">
                                <legend class="visually-hidden">${items[0].name}</legend>
                                <ul role="list" id="${listId}">
                                    ${items.map((facet, index) => `
                                        <li class="${facet.count_product === totalProductCount ? 'hidden' : ''} ${index >= this.showMaxFilterOptions ? 'js-hidden' : ''}">
                                            <input type="checkbox" class="checkbox visually-hidden focus-label-before" 
                                            id="filter-${key}-${facet.value}" name="${key}" value="${facet.value}"
                                            ${this.activeFilters[key] && this.activeFilters[key].includes(facet.value) ? 'checked' : ''}/>
                                            <label for="filter-${key}-${facet.value}" 
                                                    class="filter__label flex items-start w-full m-0">
                                                <span class="flex-auto">${facet.show_value}</span>
                                                <span class="filter__count">${facet.count_product}</span>
                                            </label>
                                        </li>
                                    `).join('')}
                                </ul>
                            </fieldset>
                            
                            <div class="flex relative items-center mt-2">
                                ${items.length > this.showMaxFilterOptions ? `<button type="button" data-list-id="${listId}"
                                    class="filter__more link text-current text-sm js-show-more">Show more</button>` : ''}
                               
                                <div class="filter__header">
                                    <a href="#" class="link text-current text-sm js-clear-filter hidden" data-list-id="${listId}">Clear</a>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                container.appendChild(detailsElement);
            });

            // Remove the preloader
            this.preloader.classList.remove('is-loading');

            this.handleShowMoreOrShowLess();
            this.handleClearOptions();
        }

        /**
         * Show More or Show Less button logic
         */
        handleShowMoreOrShowLess() {
            document.querySelectorAll('.js-show-more').forEach(button => {
                button.addEventListener('click', function() {
                    const listId = this.getAttribute('data-list-id');
                    const listItems = document.querySelectorAll(`#${listId} li`);
                    const showMaxFilterOptions = 7; //Show or Hide 7 options
                    const isExpanded = this.textContent === 'Show less';

                    if (isExpanded) {
                        listItems.forEach((item, index) => {
                            if (index >= showMaxFilterOptions) {
                                item.classList.add('js-hidden');
                            }
                        });
                        this.textContent = 'Show more';
                    } else {
                        listItems.forEach((item, index) => {
                            if (index >= showMaxFilterOptions) {
                                item.classList.remove('js-hidden');
                            }
                        });
                        this.textContent = 'Show less';
                    }
                });
            });
        }

        /**
         * Handle Clear button logic
         */
        handleClearOptions() {
            document.querySelectorAll('.disclosure').forEach(disclosure => {
                const clearButton = disclosure.querySelector('.js-clear-filter');
                const checkboxes = disclosure.querySelectorAll('input[type="checkbox"]');

                if (!clearButton || checkboxes.length === 0) {
                    return;
                }

                checkboxes.forEach(checkbox => {
                    checkbox.addEventListener('change', function() {
                        const isChecked = Array.from(checkboxes).some(cb => cb.checked);
                        if (isChecked) {
                            clearButton.classList.remove('hidden');
                        } else {
                            clearButton.classList.add('hidden');
                        }
                    });
                });

                clearButton.addEventListener('click', function(event) {
                    event.preventDefault();
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;

                        const changeEvent = new Event('click', { bubbles: true });
                        checkbox.dispatchEvent(changeEvent);
                    });

                    clearButton.classList.add('hidden');
                });
            });
        }

        /**
         * Handle facet click event
         * @param evt
         */
        handleFiltersClick(evt) {
            const target = evt.target;
            if (target.tagName !== 'INPUT') return;

            const key = target.name;
            const value = target.value;
            const isChecked = target.checked;

            if (isChecked) {
                this.addFilter(key, value);
            } else {
                this.removeFilter(key, value);
            }

            this.renderActiveFilters();
            this.renderFilteredProducts();
        }

        /**
         * Handle active facet click event
         * @param evt
         */
        handleActiveFacetsClick(evt) {
            evt.preventDefault();
            const target = evt.target;
            if (target.tagName !== 'A') return;

            const key = target.getAttribute('data-key');
            const value = target.getAttribute('data-value');

            this.removeFilter(key, value);

            // Remove active facet from the Facets section
            const facetItem = this.filters.querySelector(`input[name="${key}"][value="${value}"]`);
            if (facetItem) {
                facetItem.click();
            }
        }

        /**
         * Add filter to active filters
         * @param key
         * @param value
         */
        addFilter(key, value) {
            if (!this.activeFilters[key]) {
                this.activeFilters[key] = [];
            }
            this.activeFilters[key].push(value);
        }

        /**
         * Remove filter from active filters
         * @param key
         * @param value
         */
        removeFilter(key, value) {
            if (!this.activeFilters[key]) return;

            const index = this.activeFilters[key].indexOf(value);
            if (index > -1) {
                this.activeFilters[key].splice(index, 1);
            }

            if (this.activeFilters[key].length === 0) {
                delete this.activeFilters[key];
            }

            if (Object.keys(this.activeFilters).length === 0) {
                this.currentPage = 1;

                if (this.enabledDebug) {
                    console.log('activeFilters EMPTY-> ', this.activeFilters);
                }
            }

            //Remove active filter from the active filters section
            let issetActiveFilter= !!this.activeFiltersSection.querySelector(`a[data-value='${value}']`);
            if (issetActiveFilter) {
                this.activeFiltersSection.querySelector(`a[data-value='${value}']`).remove();
            }
        }

        /**
         * Render active filters
         */
        renderActiveFilters() {
            let filterLinks = {};

            for (const [key, values] of Object.entries(this.activeFilters)) {
                values.forEach(value => {
                    const filterLink = document.createElement('a');
                    filterLink.classList.add('active-filter', 'custom', 'flex', 'items-center', 'text-current');
                    filterLink.setAttribute('id', 'extend-active-filter');
                    filterLink.href = '#';
                    let facetItem = this.facetItems[key].find(item => item.key === key && item.value === value);

                    // Construct the inner HTML for the link
                    filterLink.innerHTML = `
                        ${facetItem ? `${facetItem.name}: ${facetItem.show_value}` : `${key}: ${value}`}
                    `;

                    // Set data attributes for removal
                    filterLink.setAttribute('data-key', key);
                    filterLink.setAttribute('data-value', value);

                    filterLinks[key] = filterLink;
                });
            }

            // Remove all active filters for re-rendering
            this.activeFiltersSection.querySelectorAll('#extend-active-filter').forEach(filter => {
                filter.remove();

                //Reset the current page to 1 after rendering the active filters
                this.currentPage = 1;
            });

            // Append the active filters to the active filters section
            for (const [key, filterLink] of Object.entries(filterLinks)) {
                this.activeFiltersSection.appendChild(filterLink);
            }

            // Update the active filters count in the header
            let getAllActiveFilters = this.activeFiltersSection.querySelectorAll('.active-filter');
            if (getAllActiveFilters.length > 0) {
                let getHeaderActiveFilters = document.querySelector('.active-filters-header');
                if (getHeaderActiveFilters) {
                    let countActiveFilters = getAllActiveFilters.length;
                    getHeaderActiveFilters.innerHTML = `${countActiveFilters} Applied Filter`;
                }

            }
        }

        /**
         * Render filtered products and pagination
         */
        renderFilteredProducts() {
            try {
                let renderFilteredProducts = {};

                if (this.activeFilters && Object.keys(this.activeFilters).length > 0) {
                    renderFilteredProducts.products = this.getFilteredProducts(this.responseProductCollection);
                    this.extendProductCollectionData(renderFilteredProducts, 'value', 'asc');
                } else {
                    renderFilteredProducts = this.responseProductCollection;
                    this.extendProductCollectionData(renderFilteredProducts, 'value', 'asc');
                }

                if (this.enabledDebug) {
                    console.log('------------------------------');
                    console.log('Products Counts->', renderFilteredProducts.products.length);
                    console.log('Filtered Products ->', renderFilteredProducts);
                    console.log('Active Filters ->', this.activeFilters);
                    console.log('------------------------------');
                }

                if (renderFilteredProducts.products.length > 0) {

                    //Preparing render the products
                    let renderedProducts = renderFilteredProducts.products.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
                    if (renderedProducts.length === 0) {
                        renderedProducts = renderFilteredProducts.products.slice(1, this.perPage);
                    }

                    // Render the products
                    this.renderProducts(renderedProducts);

                    //Scroll to the top of the results after rendering product items
                    this.scrollToTheTop();

                    let totalProductCount = renderFilteredProducts.products.length;

                    // Set count of the products
                    let showCollectionResults = document.querySelector('.js-close-drawer-mob');
                    if (showCollectionResults) {
                        showCollectionResults.innerHTML = `Show ${totalProductCount} results`;
                    }

                    // Render pagination
                    this.paginationContainer = document.querySelector('nav[aria-label="Pagination"]');
                    this.renderPagination(totalProductCount);
                }

                if (renderFilteredProducts.products.length === 0) {
                    this.results.innerHTML = '<p class="text-center">No products found with the selected filters.</p>';
                    this.paginationContainer.innerHTML = '';
                }
            } catch (error) {
                console.error('Error for renders product collection and show items: ',error);
            }
        }

        /**
         * Get filtered products based on active filters - search logic
         * @param collection
         * @returns {*}
         */
        getFilteredProducts(collection = this.productCollection) {
            if (Object.keys(this.activeFilters).length === 0) {
                return collection.products;
            }

            let getFilteredProducts =  collection.products.filter(product => {
                // Check if all filter criteria match
                return Object.keys(this.activeFilters).every(key => {
                    // Check if the product's 'extendProductItemFilters' array contains the filter key
                    let productFilter = product.node.extendProductItemFilters.find(filter => filter[key] !== undefined);
                    if (productFilter) {
                        // If found, check if the value matches one of the filter criteria
                        return this.activeFilters[key].includes(productFilter[key]);
                    }
                    // Fall back to checking the product's direct attributes (if applicable)
                    return this.activeFilters[key].includes(product.node[key]);
                });
            });

            if (getFilteredProducts.length === 0) {

                if (this.enabledDebug) {
                    console.log('No Found Products with the selected filters');
                    console.log('------------------------------');
                    console.log('Products Counts->', collection.products.length);
                    console.log('Filtered Products ->', collection);
                    console.log('Active Filters ->', this.activeFilters);
                    console.log('------------------------------');
                }

                getFilteredProducts = this.getFilteredProducts(collection);
            }

            return getFilteredProducts;
        }


        /**
         * Render the products to the DOM
         * @param products
         */
        renderProducts(products) {
            this.results.innerHTML = '';

            let productsViewBlock = '' +
                '<ul class="grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 gap-x-theme gap-y-8" ' +
                    'data-filters-open-classes="grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 gap-x-theme gap-y-8" ' +
                    'data-filters-closed-classes="grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 xl:grid-cols-4 gap-x-theme gap-y-8 mb-8 md:mb-12" ' +
                    'role="list">';

            // Sort products by boost score
            let sortedProducts = this.sortProductsByBoost(products);

            sortedProducts.forEach(product => {
                let getPriceValue = product.node.variants.edges[0].node.price.amount;
                let getPriceCurrencyCodeValue = product.node.variants.edges[0].node.price.currencyCode;
                let getPriceCompareAtPrice = product.node.variants.edges[0].node.compareAtPrice.amount;
                let getPriceCompareAtCurrencyCode = product.node.variants.edges[0].node.compareAtPrice.currencyCode;
                let getFirstVariantId = product.node.variants.edges[0].node.id;
                let getProductHandle = product.node.handle;
                let getProductTitle = product.node.title;
                let getProductVendor = product.node.vendor;
                let getProductId = product.node.id;

                const rawPriceValue = parseFloat(getPriceValue);
                const formattedPrice = this.formatPrice(getPriceValue, getPriceCurrencyCodeValue);
                const formattedCompareAtPrice = this.formatPrice(getPriceCompareAtPrice, getPriceCompareAtCurrencyCode);
                const compareAtPriceAmount = parseFloat(getPriceCompareAtPrice);
                const productId = getProductId.split("/").pop();
                const productVariantId = getFirstVariantId.split("/").pop();
                const productImageUrl = product.node.images.edges.length > 0 ? product.node.images.edges[0].node.url : '';
                const escapedTitle = getProductTitle.replace(/\\/g, '');

                let productItemHtml = '';

                productItemHtml = `<li class="js-pagination-result custom" data-boost-type="${product.node.boostType}" data-show-badge="${product.node.bestseller_product_ranking}">`;
                    if (product.node.bestseller_product_ranking) {
                        productItemHtml += `${this.productBestsellerProductRankingBadge.innerHTML}`;
                    }
                    productItemHtml += `<product-card data-item-id="${getProductId.split("/").pop()}" class="card card--product h-full card--product-contained card--no-lines relative flex" 
                                                      data-boost-score="${product.node.boostScore}">`;
                        productItemHtml += `<div class="card__media relative">`;
                            productItemHtml += `<a href="/products/${getProductHandle}" 
                                                    aria-label="${escapedTitle}" 
                                                    class="media block relative js-prod-link" 
                                                    tabindex="-1">`;
                            if (productImageUrl) {
                                productItemHtml += `<img class="product-thumbnail w-full h-auto" src="${productImageUrl}" alt="${escapedTitle}" />`;
                            } else {
                                productItemHtml += `${this.productThumbnailPlaceholder.innerHTML}`;
                            }
                            productItemHtml += `</a>`;

                            if (product.node.quick_ship) {
                                productItemHtml += `${this.productQuickshipBadge.innerHTML}`;
                            }
                        productItemHtml += `</div>`;

                        productItemHtml += `<div class="card__info-container flex flex-col flex-auto relative">`;
                            productItemHtml += `<div class="card__info w-full">`;
                                productItemHtml += `<div class="card__info-inner inline-block w-full">`;
                                    productItemHtml += `<p class="card__vendor mb-0 text-sm text-theme-light">${getProductVendor}</p>`;
                                    productItemHtml += `<p class="card__title font-bold mt-1 mb-0">`;
                                    productItemHtml += `<a href="/products/${getProductHandle}" 
                                                            class="card-link text-current js-prod-link">${escapedTitle}</a>`;
                                    productItemHtml += `</p>`;

                                    // start price
                                    if ((product.node.netsuite_item_status === this.netsuiteItemStatusObject.available || !product.node.netsuite_item_status) && rawPriceValue > 0) {
                                        productItemHtml += `<div class="price price--on-sale price--top">`;
                                            productItemHtml += `<div class="price__default">`;
                                                productItemHtml += `<strong class="price__current">${formattedPrice}</strong>`;
                                                    if (compareAtPriceAmount > 0) {
                                                        productItemHtml += `<s class="price__was">${formattedCompareAtPrice}</s>`;
                                                    }
                                                productItemHtml += `</div>`;

                                                productItemHtml += `<div class="unit-price relative" hidden="">`;
                                                    productItemHtml += `<span class="visually-hidden">Unit price</span>`;
                                                    productItemHtml += `<span class="unit-price__price"></span>`;
                                                    productItemHtml += `<span class="unit-price__separator"> / </span>`;
                                                    productItemHtml += `<span class="unit-price__unit"></span>`;
                                                productItemHtml += `</div>`;

                                                productItemHtml += `<div class="price__no-variant" hidden="">`;
                                                    productItemHtml += `<strong class="price__current">Unavailable</strong>`;
                                                productItemHtml += `</div>`;
                                        productItemHtml += `</div>`;
                                    }
                                    // end price


                                    if (product.node.free_shipping) {
                                        productItemHtml += `<div class="free-shipping-badge">`;
                                            productItemHtml += `<span>Free</span>&nbsp;<span>Shipping</span>`;
                                        productItemHtml += `</div>`;
                                    }

                                productItemHtml += `</div>`;
                            productItemHtml += `</div>`;

                            // start addform
                            if ((product.node.netsuite_item_status === this.netsuiteItemStatusObject.available || !product.node.netsuite_item_status) && rawPriceValue > 0) {
                                productItemHtml += `<div class="card__quick-add mob:card__quick-add--below desktop:card__quick-add--below">`;
                                    productItemHtml += `<product-form>`;

                                        productItemHtml += `<div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden=""></div>`;
                                        productItemHtml += `<form method="post" action="/cart/add" id="quick-add-${productId}" accept-charset="UTF-8" 
                                                            class="js-product-form" enctype="multipart/form-data" novalidate="novalidate">`;
                                            productItemHtml += `<input type="hidden" name="form_type" value="product">`;
                                            productItemHtml += `<input type="hidden" name="utf8" value="✓">`;
                                            productItemHtml += `<input type="hidden" name="id" value="${productVariantId}">`;
                                            productItemHtml += `<button class="btn ${this.productItemAddToCartBtnClass} w-full" data-add-to-cart-text="${this.addToCartText}" name="add" aria-haspopup="dialog">`;
                                                productItemHtml += `<span class="quick-add-btn-icon">`;
                                                    productItemHtml += `<span class="visually-hidden">${this.addToCartText}</span>`;
                                                productItemHtml += `</span>`;
                                                productItemHtml += `<span class="quick-add-btn-text">${this.addToCartText}</span>`;
                                            productItemHtml += `</button>`;
                                            productItemHtml += `<a href="/products/${getProductHandle}" class="btn btn--secondary quick-add-view-btn">View details</a>`;
                                            productItemHtml += `<input type="hidden" name="product-id" value="${productId}">`;
                                        productItemHtml += `</form>`;
                                    productItemHtml += `</product-form>`;
                                productItemHtml += `</div>`;
                            } else {
                                if (product.node.netsuite_item_status === this.netsuiteItemStatusObject.discontinued && product.node.replacement_item_handle) {
                                    productItemHtml += `
                                            <div class="product-info__replacement-model">
                                                <button type="button"
                                                        onclick="window.open('https://${Shopify.shop + '/products/' + product.node.replacement_item_handle}', '_blank')"
                                                        class="btn btn--secondary w-full view-replacement-item-button js-loaded">${this.viewReplacementItemText}</button>
                                            </div>
                                        `;
                                } else {
                                    productItemHtml += `
                                        <div class="product-info__call-richpanel">
                                            <button type="button"
                                                onclick="window.location.href='${this.richpanel_link}'"
                                                class="btn btn--secondary w-full request-quote-button js-loaded">${this.requestAQuoteText}</button>
                                        </div>
                                    `;
                                }
                            }
                            // end addform

                        productItemHtml += `</div>`;
                    productItemHtml += `</product-card>`;
                productItemHtml += `</li>`;

                productsViewBlock += productItemHtml;
            });
            productsViewBlock += '</ul>';

            productsViewBlock += '<nav aria-label="Pagination">';
            productsViewBlock += '</nav>';

            // Reinitialize lazyload images after filters applied.
            if (typeof initLazyImages === 'function') initLazyImages();

            //Render of the products for the results block
            this.results.innerHTML = productsViewBlock;
        }

        /**
         * Format the price
         * @param price
         * @param currencyCode
         * @returns {string}
         */
        formatPrice(price, currencyCode) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode
            }).format(price);
        }

        /**
         * Sort products by boost score
         * @param products
         * @returns {*}
         */
        sortProductsByBoost(products) {
            let sortedProducts = [];
            let high_priority_products = [];
            let medium_priority_products = [];
            let default_priority_products = [];
            let low_priority_products = [];
            let suppressed_products = [];

            products.forEach(product => {
                let score = this.calculateBoostScore(product.node);

                // Categorize products based on their boost score
                if (score >= 50) {
                    product.node.boostType = 'high_priority';
                    high_priority_products.push(product);
                } else if (score >= 1 && score <= 49) {
                    product.node.boostType = 'medium_priority';
                    medium_priority_products.push(product);
                } else if (score === 0) {
                    product.node.boostType = 'default_priority';
                    default_priority_products.push(product);
                } else if (score <= -1) {
                    product.node.boostType = 'low_priority';
                    low_priority_products.push(product);
                } else {
                    product.node.boostType = 'suppressed';
                    suppressed_products.push(product);
                }
            });

            sortedProducts = [
                ...high_priority_products,
                ...medium_priority_products,
                ...default_priority_products,
                ...low_priority_products,
                ...suppressed_products
            ];

            return sortedProducts;
        }

        /**
         * Calculate the boost score for a product
         * @param product
         * @returns {number}
         */
        calculateBoostScore(product) {

            let boostScore = 0;
            if (product) {
                // RS QuickShip
                if (product.rs_qs_inventory === true) {
                    boostScore += 20;
                }

                // QuickShip
                if (product.quick_ship === true) {
                    boostScore += 20;
                }

                // Vendors
                if (this.boostVendors && this.boostVendors.includes(product.vendor)) {
                    boostScore += 20;
                }

                // Vendor AllPoints
                if (this.boostAllPointsVendors && this.boostAllPointsVendors.includes(product.vendor)) {
                    boostScore -= 20;
                }

                // NetSuite Item Status
                if (product.netsuite_item_status) {
                    let netsuiteItemStatusValue = product.netsuite_item_status ?? null;

                    // Adjust boost score based on NetSuite Item Status
                    if (netsuiteItemStatusValue === this.netsuiteItemStatusDiscontinued || netsuiteItemStatusValue === this.netsuiteItemStatusOutOfStock) {
                        boostScore -= 100;
                    } else if (netsuiteItemStatusValue === this.netsuiteItemStatusSpecialQuoteItem) {
                        boostScore -= 10;
                    }
                }

                // Product Price
                if (product.price === 0) {
                    boostScore -= 10;
                }

                // Product Image
                if (product.images.edges && product.images.edges.length === 0) {
                    boostScore -= 10;
                }

                product.boostScore = boostScore;
            }
            return boostScore;
        }

        /**
         * Scroll to the top of the results block
         */
        scrollToTheTop() {
            // Scroll to the top of the results if needed
            if (this.results.getBoundingClientRect().top < 0) {
                // If the header is sticky, compensate for it when scrolling to elements
                let headerHeight = 0;
                if (document.querySelector('store-header[data-is-sticky="true"]')) {
                    headerHeight = Number.parseInt(
                        getComputedStyle(this.parentElement)
                            .getPropertyValue('--header-height')
                            .replace('px', ''),
                        10
                    ) || 0;
                }
                window.scrollTo({
                    top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
                    behavior: 'smooth'
                });
            }
        }

        /**
         * Render pagination
         * @param totalProducts
         */
        renderPagination(totalProducts) {
            const totalPages = Math.ceil(totalProducts / this.perPage);
            const maxVisiblePages = 5; // Number of visible middle pages
            const firstPage = 1;
            const lastPage = totalPages;

            if (this.paginationContainer !== null && totalPages > 1) {
                this.paginationContainer.innerHTML = '';

                // Create the <ul> element
                const ulElement = document.createElement('ul');
                ulElement.classList.add('pagination', 'custom', 'relative', 'flex', 'flex-wrap', 'justify-center', 'items-center',
                    'justify-between', 'w-full', 'mx-auto', 'mb-10', 'js-pagination');
                ulElement.setAttribute('data-is-more-results', 'true');
                ulElement.setAttribute('data-pagination-style', 'traditional');

                // Create "Previous" button
                const prevButtonItem = document.createElement('li');
                prevButtonItem.classList.add('pagination__item', 'pagination__item--arrow');
                const prevButton = document.createElement('a');
                prevButton.classList.add('pagination__arrow', 'pagination__arrow--prev', 'hover:lighten', 'flex',
                    'text-current', 'items-center', 'has-ltr-icon');
                prevButton.href = '#';
                prevButton.setAttribute('role', 'link');
                prevButton.setAttribute('aria-disabled', this.currentPage === firstPage);
                prevButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.currentPage > firstPage) {
                        this.currentPage--;
                        this.renderFilteredProducts();
                    }
                });
                prevButton.innerHTML = `Previous`;
                prevButtonItem.appendChild(prevButton);
                ulElement.appendChild(prevButtonItem);

                // Always show the first page
                this.createPageButton(ulElement, firstPage);

                // Show ellipsis after the first page if necessary
                if (this.currentPage > 4) {
                    this.createEllipsis(ulElement);
                }

                // Calculate the range of middle pages to display
                let startPage = Math.max(this.currentPage - 2, 2);
                let endPage = Math.min(this.currentPage + 2, lastPage - 1);

                // Adjust start and end page if near boundaries
                if (this.currentPage <= 4) {
                    startPage = 2;
                    endPage = Math.min(maxVisiblePages, lastPage - 1);
                } else if (this.currentPage >= lastPage - 3) {
                    startPage = Math.max(lastPage - maxVisiblePages + 1, 2);
                    endPage = lastPage - 1;
                }

                // Display middle pages
                for (let i = startPage; i <= endPage; i++) {
                    this.createPageButton(ulElement, i);
                }

                // Show ellipsis before the last page if necessary
                if (this.currentPage < lastPage - 3) {
                    this.createEllipsis(ulElement);
                }

                // Always show the last page
                if (lastPage > 1) {
                    this.createPageButton(ulElement, lastPage);
                }

                // Create "Next" button
                const nextButtonItem = document.createElement('li');
                nextButtonItem.classList.add('pagination__item', 'pagination__item--arrow');
                const nextButton = document.createElement('a');
                nextButton.classList.add('pagination__arrow', 'pagination__arrow--next', 'hover:lighten', 'flex',
                    'justify-end', 'text-current', 'items-center', 'has-ltr-icon');
                nextButton.href = '#';
                nextButton.setAttribute('role', 'link');
                nextButton.setAttribute('aria-disabled', this.currentPage === lastPage);
                nextButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.currentPage < lastPage) {
                        this.currentPage++;
                        this.renderFilteredProducts();
                    }
                });
                nextButton.innerHTML = `Next`;
                nextButtonItem.appendChild(nextButton);
                ulElement.appendChild(nextButtonItem);

                // Append the <ul> to the pagination container
                this.paginationContainer.appendChild(ulElement);
            }
        }

        /**
         * Helper function to create a page button
         * @param ulElement
         * @param pageNumber
         */
        createPageButton(ulElement, pageNumber) {
            const pageItem = document.createElement('li');
            pageItem.classList.add('hidden', 'md:block');

            const pageButton = document.createElement(pageNumber === this.currentPage ? 'span' : 'a');
            pageButton.classList.add('pagination__page-link', 'text-current', 'block', 'leading-none');
            pageButton.innerText = pageNumber;

            if (pageNumber === this.currentPage) {
                pageButton.classList.add('pagination__page-current', 'font-bold');
            } else {
                pageButton.href = '#';
                pageButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.currentPage = pageNumber;
                    this.renderFilteredProducts();
                });
            }

            pageItem.appendChild(pageButton);
            ulElement.appendChild(pageItem);
        }

        /**
         * Helper function to create ellipsis
         * @param ulElement
         */
        createEllipsis(ulElement) {
            const ellipsisItem = document.createElement('li');
            ellipsisItem.innerText = '…';
            ellipsisItem.classList.add('pagination__ellipsis');
            ulElement.appendChild(ellipsisItem);
        }
    }

    customElements.define('extended-filters', AdditionalFacetFilters);
}
